import React from 'react'
import './footer.css'

function Footer() {
  return (
    <div>
        <div className="mt-5 pt-5 pb-5 footer">
            <div className="container">
            <div className="row">
                <div className="col-lg-5 col-xs-12 about-company">
                <h2 className='footer-title'>Shrimad Bhagvat Geeta</h2>
                <p className="pr-5 text-white-50 footer-slok">कर्मण्येवाधिकारस्ते मा फलेषु कदाचन। <br/>मा कर्मफलहेतुर्भुर्मा ते संगोऽस्त्वकर्मणि॥</p>
                <p><a href="https://www.facebook.com/deep.bhuva.1"><i className="fa fa-facebook-square mr-1"></i></a>
                    <a href="https://www.linkedin.com/in/deep-bhuva-878ab0222/"><i className="fa fa-linkedin-square"></i></a>
                    <a href="https://github.com/DEEPBHUVA"><i className="fa fa-github-square"></i></a>
                    <a href="https://twitter.com/Deep_Bhuva_?t=YZP7K5jBXHcTJHmWkicf-Q&s=08"><i className="fa fa-twitter-square"></i></a>
                    </p>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col copyright">
                <p className=""><small class="text-white-50">© 2023. All Rights Reserved.</small></p>
                </div>
            </div>
            </div>
        </div>
    </div>
  )
}

export default Footer